module.exports = __webpack_public_path__ + "img/icon-wrench.57257d15.svg";